import { useState, useEffect, useCallback } from "react";
import { api, errMsg } from "../lib/api";

// Simple data hooks against the live API (demo mode retired).
export function useGet(path, { enabled = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    try {
      const r = await api.get(path);
      setData(r.data);
    } catch (e) {
      setError(errMsg(e));
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [path, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, setData, loading, error, refetch: load };
}
